import React from 'react';
import ReactDOM from 'react-dom';
import { configureAuth } from './config/auth.config';
import { configureApi } from './config/api.config';
import { configureLogging} from './config/logging.config';
import "./index.scss";
import {AuthenticatedApp} from './App';
import { configureAppInsights } from './config/appInsights.config';
import { setUpAppInsights } from './AppInsights';

let loadConfig = async()=>{
  if (process.env.NODE_ENV !== 'development') {
    console.log = function() {};
  }
  if (process.env.NODE_ENV==='production') {
    return await fetch('./configuration.json').then(res=>res.json());
  }
  return import('./configuration.json')
}

loadConfig().then(res=>{
  configureAuth(res);
  configureApi(res);
  configureLogging(res);
  configureAppInsights(res)
  setUpAppInsights();
  
  ReactDOM.render(
    <React.StrictMode>
      <AuthenticatedApp />
    </React.StrictMode>,
    document.getElementById('root')
  );
})

export async function getConfig()
{
  return await loadConfig();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(logger.log);
